import { commonFinalizingHireStepsStateSelector } from '../../reducers/job-selectors';
import { createGenericDispatcher } from '../action-dispatcher-factory';

import Job from '../../api/job-api-client';

export const loadCommonFinalizingHireSteps = () =>
  createGenericDispatcher({
    name: 'JOB_COMMON_FINALIZING_HIRE_STEPS',
    loadFunction: Job.getCommonFinalizingHireSteps,
    args: {},
    shouldExecuteSelector: commonFinalizingHireStepsStateSelector,
  });
